import Theme from '../types/theme';
import antique from './antiqueTheme';
import dark from './darkTheme';
import highContrast from './highContrastTheme';
import light from './lightTheme';
import modern from './modernTheme';
import { designTokens } from '../tokens';

export type ThemeNames = 'antique' | 'dark' | 'highContrast' | 'light' | 'modern';

const themes = new Map();
themes.set('antique', antique);
themes.set('dark', dark);
themes.set('highContrast', highContrast);
themes.set('light', light);
themes.set('modern', modern);

export const getDefaultTheme = (): ThemeNames => 'dark';

export const getDefaultThemes = (): Map<string, Theme> => {
  return themes;
};

export const getThemeFromName = (themeName: ThemeNames): Theme => {
  let theme = getDefaultThemes().get(themeName);

  if (!theme) {
    console.error('theme not found reverting to the dark default theme');
    theme = getDefaultThemes().get(getDefaultTheme());
  }

  return {
    ...designTokens,
    ...theme,
    otherThemes: {
      antique,
      dark,
      highContrast,
      light,
    },
  } as Theme;
};
